import React, { useState } from "react";
import styled from "styled-components";
import { colors } from "../../../../utils/theme";
import { Link, useNavigate } from "react-router-dom";

import Swal from "sweetalert2";

import { useDataContex } from "../../../../hooks/Context/PatientProvider";
import { IPatiendObjet } from "../../../../interfaces/Patient";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .container_parrafos {
    display: flex;
    flex-direction: column;
    width: 90%;
    margin: 2rem auto;
    text-align: start;
    gap: 10px;
    @media (max-width: 500px) {
      padding: 0;
    }
    p {
      font-size: 1.2rem;
      color: ${colors.fifth};
      margin-bottom: 2rem;
      @media (max-width: 500px) {
        margin-bottom: 0;
        font-size: 1.1rem;
      }
      @media (max-width: 500px) {
        font-size: 1rem;
      }
    }
    span {
      font-weight: bold;
    }
  }

  .Container_button {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 2rem;

    .button,
    button {
      width: 15%;
      display: block;
      padding: 0.5rem;
      border: none;
      border-radius: 30px;
      color: ${colors.blanco};
      background-color: ${colors.azul};
      font-weight: bold;
      text-decoration: none;
      text-align: center;
      @media (max-width: 1200px) {
        width: 20%;
      }
      @media (max-width: 900px) {
        width: 25%;
      }
      @media (max-width: 768px) {
        width: 35%;
      }
      @media (max-width: 500px) {
        width: 40%;
      }
      @media (max-width: 500px) {
        font-size: 0.7rem;
      }
    }
    .cancelar {
      background-color: ${colors.primary};
    }
  }
`;

const ModalContent = styled.div`
  width: 80%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  text-align: center;
  margin: 0;

  h2 {
    color: ${colors.primary};
    background-color: ${colors.gris};
    padding: 1rem 0;
    font-size: 1.5rem;
    margin: 0;
    font-weight: bold;

    @media (max-width: 500px) {
      font-size: 1.2rem;
    }
    @media (max-width: 500px) {
      font-size: 1rem;
    }
  }
`;

const Button = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;

  button {
    width: 20%;
    display: block;
    padding: 0.7rem;
    border: none;
    border-radius: 30px;
    color: ${colors.blanco};
    background-color: ${colors.azul};
    margin-bottom: 2rem;
    font-weight: bold;
    @media (max-width: 1440px) {
      width: 30%;
    }
    @media (max-width: 1024px) {
      width: 40%;
    }
    @media (max-width: 768px) {
      width: 50%;
    }
    @media (max-width: 600px) {
      width: 80%;
    }
    @media (max-width: 350px) {
      font-size: 0.8rem;
    }
  }
`;

const PopupContiniudad = ({ orderId, numDocu }) => {
  // Estado para controlar la visibilidad del modal
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  // Uso de un hook personalizado para obtener datos
  const { data, data2, CalendarData, TimeData, patientInfoContinuidadContex } =
    useDataContex();

  // Extracción del último elemento de los diferentes arrays de datos
  const dataSet = data?.[data2.length - 1];
  const dataSet2 = CalendarData?.[CalendarData.length - 1];
  const dataSet3 = TimeData?.[TimeData.length - 1];
  const dataSet4 = data2?.[data2.length - 1];
  // Construcción del nombre completo del paciente y conversión a mayúsculas
  const parts2 = [
    dataSet?.firstName?.field,
    // dataSet?.LastName?.field,
    dataSet?.lastName?.field,
    // dataSet?.LastSurname?.field,
  ].filter(Boolean);
  const NameCompletePatient = parts2.join(" ").toUpperCase();

  // Verificación de la validez de la fecha y hora seleccionadas
  const IsvalidCalendar = dataSet2?.DateCalendar?.valido;
  const IsvalidTime = dataSet3?.appointmentTime?.date;

  const fechaSeleccionada = dataSet2?.DateCalendar?.date;
  const horaSeleccionada = dataSet3?.appointmentTime?.date;
  const horaSeleccionadaNumero = parseInt(horaSeleccionada, 10);
  const [horaFormated, sethoraFormated] = useState("");

  const { patientInformationContext } = useDataContex();

  const ID = patientInfoContinuidadContex?.tipoDocumento;
  const IDNumber = patientInfoContinuidadContex?.numeroDocumento;

  const parts = [
    dataSet?.birthDay?.field,
    dataSet?.birthMonth?.field,
    dataSet?.birthYear?.field,
  ].filter(Boolean);

  // Función para manejar la apertura del modal
  const handleOpenModal = () => {
    if (IsvalidCalendar && IsvalidTime) {
      const displayHour =
        Number(dataSet3.appointmentTime.field) % 12 === 0
          ? 12
          : Number(dataSet3.appointmentTime.field) % 12;
      const amPm =
        Number(dataSet3.appointmentTime.field) < 12 ? ":00 AM" : ":00 PM";
      sethoraFormated(displayHour + amPm);
      setShowModal(true);
    } else if (!IsvalidCalendar) {
      Swal.fire(
        "Ya digitó la de fecha de atención?",
        "Digite Su Fecha!",
        "question"
      );
    } else if (!IsvalidTime) {
      Swal.fire(
        "Ya digitó la hora de atención?",
        "Digite Su Hora de atención!",
        "question"
      );
    }
  };

  // Función para manejar el cierre del modal
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const fechaActualUTC = fechaSeleccionada;
  const hora = horaSeleccionadaNumero;

  async function postNuevoAgendamientoContinuidad(hora, fecha) {
    const url = "/apihub/legacy/Service/Agenda/NuevoAgendamientoContinuidad";
    const requestBody = {
      fecha: fecha,
      hora: hora,
      numeroDeOrden: orderId,
      numeroDeDocumento: numDocu,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (!response.ok) {
        var error = new Error(`HTTP error! status: ${response.status}`) as any;
        error.data = data;
        throw error;
      }
      return data;
    } catch (error) {
      throw error;
    }
  }

  async function CriteriosAsignacionCita(numeroDocumento, tipoDocumento, fecha, hora) {
    const url = "/apihub/legacy/Service/CriteriosAsignacionCita";

    const requestBody = {
      patient_id: numeroDocumento,
      patient_id_type: tipoDocumento,
      date: fecha,
      hour: hora,
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (!response.ok) {
        var error = new Error(`HTTP error! status: ${response.status}`) as any;
        error.data = data;
        throw error;
      }
      return data;
    } catch (error) {
      throw error;
    }
  }

  const handleClick = async () => {
    CriteriosAsignacionCita(IDNumber, ID, fechaActualUTC, hora)
      .then((data) => {
        if (data && data.data) {
          if (data.data.puedeCrearAgenda) {
            Swal.fire({
              title: "¡Puede Continuar Con Agendamiento!",
              icon: "success",
              timer: 2000,
              html: data.data.validations[0].message,
              showConfirmButton: false,
            });

            postNuevoAgendamientoContinuidad(hora, fechaActualUTC)
              .then((data) => {
                const Paciente = data.data.paciente;
                if (data && data.data) {
                  setTimeout(() => {
                    navigate("/ResumenCitaContinuidad", {
                      state: { Paciente, fechaActualUTC },
                    });
                  }, 1500);
                } else {
                  Swal.fire({
                    title: "¡Error al agendar!",
                    icon: "error",
                    timer: 1500,
                    html: "error al agendar el paciente",
                    showConfirmButton: false,
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
                var messege = error.data.errors.join("</br>");
                Swal.fire({
                  title: "¡Error en el formulario!",
                  icon: "error",
                  timer: 1500,
                  html: messege,
                  showConfirmButton: false,
                });
              });
          } else {
            Swal.fire({
              title: "¡No Puede Continuar Con Agendamiento!",
              icon: "error",
              timer: 5000,
              html: data.data.validations[0].message,
              showConfirmButton: false,
            });
          }
        } else {
          Swal.fire({
            title: "¡Error al validar el estado del agendamiento!",
            icon: "error",
            timer: 2500,
            html: data.data.validations[0].message,
            showConfirmButton: false,
          });
        }
      })
      .catch((error) => {
        console.log("error", error);
        var messege = error.data.errors.join("</br>");
        Swal.fire({
          title: "¡Error en el formulario!",
          icon: "error",
          timer: 1500,
          html: messege,
          showConfirmButton: false,
        });
      });
  };

  return (
    <div>
      <Button onClick={handleOpenModal}>
        <button>CONFIRMAR AGENDAMIENTO</button>
      </Button>

      {showModal && (
        <ModalOverlay>
          <ModalContent>
            <h2>CONFIRMACIÓN AGENDAMIENTO</h2>

            <div className="container_parrafos">
              <p>Estimado(a) {NameCompletePatient},</p>
              <p>
                Le confirmamos que su cita para nuevo diagnóstico será
                programada para el{" "}
                <span>
                  {dataSet2.DateCalendar.campo}, a las {horaFormated}, en la
                  sede de Mi Físico CRA 50 # 84 - 45.
                </span>
              </p>
              <p>
                Confirmar su cita, por favor haga clic en el botón de{" "}
                <span>CONFIRMAR CITA.</span> Si necesita hacer algún cambio en
                su cita, por favor haga clic en el botón de{" "}
                <span>
                  CORREGIR CITA.
                  <br />
                  <br />
                </span>{" "}
                Agradecemos su confianza en nosotros.
              </p>
            </div>
            <div className="Container_button">
              <Link onClick={handleClick} className="button" to="">
                CONFIRMAR CITA
              </Link>
              <button className="cancelar" onClick={handleCloseModal}>
                CORREGIR CITA
              </button>
            </div>
          </ModalContent>
        </ModalOverlay>
      )}
    </div>
  );
};

export default PopupContiniudad;
